// TODO(SOFTWARE-2981): Can we retire this now that RoSy is live?
export enum TemplateSerial {
  BUD = "BudTemplate",
  REAPER = "ReaperTemplate",
  RTC = "RtcTemplate",
  SIMULATOR = "SimTemplate",
  SLAYER = "Template",
  MODULE_VALIDATION_STATION = "MvsTemplate",
}
